var map = {
	"./": 11630,
	"./en_US": 39678,
	"./en_US.js": 39678,
	"./index": 11630,
	"./index.js": 11630,
	"./ko_KR": 49881,
	"./ko_KR.js": 49881,
	"./kz_KZ": 98284,
	"./kz_KZ.js": 98284,
	"./mn_MN": 96635,
	"./mn_MN.js": 96635,
	"./ru_RU": 24199,
	"./ru_RU.js": 24199
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67976;
module.exports = webpackAsyncContext;